'use client';

import type { PlayersLeaderboardDtoPaginatedList } from '@/api/backoffice-zod-schemas';
import { Pagination } from '@/components/pagination';
import { getPlayerRankInLeaderboard } from '@/utils/pickems';
import { LeaderboardTableHeader } from './LeaderboardTableHeader';
import { LeaderboardTableRow } from './LeaderboardTableRow';

export const PickemsLeaderboardTable = ({
  data,
  onPageChange,
}: {
  data: PlayersLeaderboardDtoPaginatedList;
  onPageChange: (page: number) => void;
}) => {
  const players = data?.items ?? [];

  const currentPage = data?.pageNumber ?? 1;
  const totalPages = data?.totalPages ?? 1;
  const totalCount = data.totalCount ?? 0;
  const perPageItems = 10;

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-lg bg-dark-gray p-4">
        {players.length === 0 ? (
          <p className="px-12 py-48 text-center font-semibold text-white text-xl">
            No players have bet on any picks yet. Check back later to see the
            leaderboard.
          </p>
        ) : (
          <table className="w-full border-separate border-spacing-y-2 text-sm">
            <LeaderboardTableHeader />
            <tbody>
              {players.map((item, index) => {
                const userName = item.user?.userName ?? undefined;

                return (
                  <LeaderboardTableRow
                    data={{
                      userName,
                      points: item.points,
                      totalPicks: item.totalPicks,
                      totalWinPicks: item.totalWinPicks,
                    }}
                    // NOTE: user.id is null for some reason
                    key={userName}
                    rank={getPlayerRankInLeaderboard({
                      indexOnCurrentPage: index,
                      perPagePlayers: perPageItems,
                      currentPage,
                    })}
                  />
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {data && totalCount > 0 && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          onChange={onPageChange}
          perPageItems={perPageItems}
          // TODO: assuming it's 10, it's not in any query param
          totalCount={totalCount}
          totalPages={totalPages}
        />
      )}
    </div>
  );
};
